import { render, staticRenderFns } from "./controlpanel.vue?vue&type=template&id=51062253"
import script from "./controlpanel.js?vue&type=script&lang=js&external"
export * from "./controlpanel.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports